/** Section wrapper shared by the detail drawers (issue / site / hod): an uppercase label above its
 *  children. Single source of truth so all three drawers keep identical section typography + spacing.
 *  `card` wraps the children in a bordered card so the section reads as a distinct block. */
export function Section({
  label,
  card = false,
  children,
}: {
  label: string
  card?: boolean
  children: React.ReactNode
}) {
  return (
    <div className="mb-[22px]">
      <div className="mb-[10px] text-[10.5px] font-bold tracking-[.08em] text-gis-heading uppercase">{label}</div>
      {card ? <div className="rounded-[14px] border border-gis-line bg-white p-[14px]">{children}</div> : children}
    </div>
  )
}
